import React from 'react'
import PropTypes from 'prop-types'
import MaskedInput from 'react-text-mask'

import InputWithLoader from './InputWithLoader';
import { phoneMask } from '../utils';

function PhoneNumberInput(props) {
  return (
    <InputWithLoader 
      {...props}
      tag={MaskedInput}
      guide={true}
      mask={phoneMask}
    />
  )
}

PhoneNumberInput.propTypes = {

}

export default PhoneNumberInput

